
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/textile/products/textile-production-process-optimization-software",
      function () {
        return require("private-next-pages/industries/textile/products/textile-production-process-optimization-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/textile/products/textile-production-process-optimization-software"])
      });
    }
  